export const FORM_PROJECT = 'FORM_PROJECT';
export const GET_PROJECTS = 'GET_PROJECTS';
export const ADD_PROJECTS = 'ADD_PROJECTS';
export const FORM_VALIDATION = 'FORM_VALIDATION';
export const ACTUAL_PROJECT = 'ACTUAL_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const ERROR_PROJECT = 'ERROR_PROJECT';

export const TASK_PROJECT = 'TASK_PROJECT';
export const ADD_TASK = 'ADD_TASK';
export const CHECK_TASK = 'CHECK_TASK';
export const DELETE_TASK = 'DELETE_TASK';
export const ACTUAL_TASK = 'ACTUAL_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const CLEAR_TASK = 'CLEAR_TASK';

export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

export const SUCCESSFUL_REGISTRATION = 'SUCCESSFUL_REGISTRATION';
export const ERROR_REGISTRATION = 'ERROR_REGISTRATION';
export const GET_USER = 'GET_USER';
export const SUCCESSFUL_LOGIN = 'SUCCESSFUL_LOGIN';
export const ERROR_LOGIN = 'ERROR_LOGIN';
export const LOG_OUT = 'LOG_OUT';
export const LOADING = 'LOADING'